import type { FlowStep } from '@/data'

export {
  type FormFieldName,
  requiredFormFieldIds,
  availableFormInputs,
} from '../shared/config'

export const defaultSteps: FlowStep[] = [
  {
    ordinal: 1,
    headline: 'Share a bit about yourself in just 30 seconds!',
    sub_headline: '',
    cta_button: 'Check Eligibility*',
    inputs: [
      {
        id: 'name',
        label: 'Full Name',
        type: 'text',
        placeholder: null,
        required: true,
      },
      {
        id: 'email',
        label: 'Email Address',
        type: 'email',
        placeholder: null,
        required: true,
      },
      {
        id: 'phone',
        label: 'Phone Number',
        type: 'phone',
        placeholder: null,
        required: true,
      },
    ],
  },
  {
    ordinal: 2,
    headline: "You're one step away!",
    sub_headline:
      'In this last step you can learn which plan you qualify for by filling in the information below.',
    cta_button: 'Submit',
    inputs: [
      {
        id: 'birthdate',
        label: 'Date of Birth',
        type: 'text',
        placeholder: null,
        required: true,
      },
      {
        id: 'address',
        label: 'Address',
        type: 'text',
        placeholder: null,
        required: true,
      },
    ],
  },
]

export function validateSteps(steps: FlowStep[]): string[] {
  const errors: string[] = []
  const allInputIds = new Set<string>()
  steps.forEach((s) => s.inputs.forEach((i) => allInputIds.add(i.id)))

  const missing: string[] = []
  if (!allInputIds.has('name')) missing.push('Name')
  if (!allInputIds.has('email')) missing.push('Email')
  if (!allInputIds.has('phone')) missing.push('Phone')

  if (missing.length > 0) {
    errors.push(`Missing required field(s): ${missing.join(', ')}`)
  }

  return errors
}
